import React from "react"
import css from "./page404.module.scss"

const Page404 = () => {
  return <div className="travels-page page-content">Страница не найдена</div>
}

export default Page404
